// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-svgPath-svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.cesium-button {
  display: inline-block;
  position: relative;
  background: #303336;
  border: 1px solid #444;
  color: #edffff; /* For text buttons */
  fill: #edffff; /* For SVG buttons */
  border-radius: 4px;
  padding: 5px 12px;
  margin: 2px 3px;
  cursor: pointer;
  overflow: hidden;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cesium-button:focus {
  color: #fff; /* For text buttons */
  fill: #fff; /* For SVG buttons */
  border-color: #ea4;
  outline: none;
}

.cesium-button:hover {
  color: #fff; /* For text buttons */
  fill: #fff; /* For SVG buttons */
  background: #48b;
  border-color: #aef;
  box-shadow: 0 0 8px #fff;
}

.cesium-button:active {
  color: #000; /* For text buttons */
  fill: #000; /* For SVG buttons */
  background: #adf;
  border-color: #fff;
  box-shadow: 0 0 8px #fff;
}

.cesium-button:disabled,
.cesium-button-disabled,
.cesium-button-disabled:focus,
.cesium-button-disabled:hover,
.cesium-button-disabled:active {
  background: #303336;
  border-color: #444;
  color: #646464; /* For text buttons */
  fill: #646464; /* For SVG buttons */
  box-shadow: none;
  cursor: default;
}

.cesium-button option {
  background-color: #000;
  color: #eee;
}

.cesium-button option:disabled {
  color: #777;
}

.cesium-button input,
.cesium-button label {
  cursor: pointer;
}

.cesium-button input {
  vertical-align: sub;
}

.cesium-toolbar-button {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  border-radius: 14%;
  padding: 0;
  vertical-align: middle;
  z-index: 0; /* Workaround for rounded raster image corners in Chrome */
}

.cesium-performanceDisplay-defaultContainer {
  position: absolute;
  top: 50px;
  right: 10px;
  text-align: right;
}

.cesium-performanceDisplay {
  background-color: rgba(40, 40, 40, 0.7);
  padding: 7px;
  border-radius: 5px;
  border: 1px solid #444;
  font: bold 12px sans-serif;
}

.cesium-performanceDisplay-fps {
  color: #e52;
}

.cesium-performanceDisplay-throttled {
  color: #a42;
}

.cesium-performanceDisplay-ms {
  color: #de3;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/shared.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc,EAAE,qBAAqB;EACrC,aAAa,EAAE,oBAAoB;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,UAAU,EAAE,oBAAoB;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,UAAU,EAAE,oBAAoB;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,UAAU,EAAE,oBAAoB;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc,EAAE,qBAAqB;EACrC,aAAa,EAAE,oBAAoB;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,UAAU,EAAE,0DAA0D;AACxE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".cesium-svgPath-svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.cesium-button {\n  display: inline-block;\n  position: relative;\n  background: #303336;\n  border: 1px solid #444;\n  color: #edffff; /* For text buttons */\n  fill: #edffff; /* For SVG buttons */\n  border-radius: 4px;\n  padding: 5px 12px;\n  margin: 2px 3px;\n  cursor: pointer;\n  overflow: hidden;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cesium-button:focus {\n  color: #fff; /* For text buttons */\n  fill: #fff; /* For SVG buttons */\n  border-color: #ea4;\n  outline: none;\n}\n\n.cesium-button:hover {\n  color: #fff; /* For text buttons */\n  fill: #fff; /* For SVG buttons */\n  background: #48b;\n  border-color: #aef;\n  box-shadow: 0 0 8px #fff;\n}\n\n.cesium-button:active {\n  color: #000; /* For text buttons */\n  fill: #000; /* For SVG buttons */\n  background: #adf;\n  border-color: #fff;\n  box-shadow: 0 0 8px #fff;\n}\n\n.cesium-button:disabled,\n.cesium-button-disabled,\n.cesium-button-disabled:focus,\n.cesium-button-disabled:hover,\n.cesium-button-disabled:active {\n  background: #303336;\n  border-color: #444;\n  color: #646464; /* For text buttons */\n  fill: #646464; /* For SVG buttons */\n  box-shadow: none;\n  cursor: default;\n}\n\n.cesium-button option {\n  background-color: #000;\n  color: #eee;\n}\n\n.cesium-button option:disabled {\n  color: #777;\n}\n\n.cesium-button input,\n.cesium-button label {\n  cursor: pointer;\n}\n\n.cesium-button input {\n  vertical-align: sub;\n}\n\n.cesium-toolbar-button {\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  border-radius: 14%;\n  padding: 0;\n  vertical-align: middle;\n  z-index: 0; /* Workaround for rounded raster image corners in Chrome */\n}\n\n.cesium-performanceDisplay-defaultContainer {\n  position: absolute;\n  top: 50px;\n  right: 10px;\n  text-align: right;\n}\n\n.cesium-performanceDisplay {\n  background-color: rgba(40, 40, 40, 0.7);\n  padding: 7px;\n  border-radius: 5px;\n  border: 1px solid #444;\n  font: bold 12px sans-serif;\n}\n\n.cesium-performanceDisplay-fps {\n  color: #e52;\n}\n\n.cesium-performanceDisplay-throttled {\n  color: #a42;\n}\n\n.cesium-performanceDisplay-ms {\n  color: #de3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
